import type { FC } from 'react';
import { Picture } from '@ui';
import icons from '@icons';
import type { HeaderSearchSettings } from '../..';
import { observer } from 'mobx-react';
import './index.scss';

const {
  close: { darkGrey: closeDGOutlined, red: closeRedOutined },
  search: { darkGrey: searchDGOutlined }
} = icons.Outline;

interface SearchInputProps {
  value: string;
  onChange: HeaderSearchSettings['searchHeader'];
  onFocus?: () => void;
  onBlur?: () => void;
  onKeyUp?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  clearInput: () => void;
  onClickForExample?: () => void;
  itemForExample?: string;
  compact?: boolean;
  id?: string;
}

const SearchInput: FC<SearchInputProps> = ({
  value,
  onChange,
  onFocus,
  onBlur,
  onKeyUp,
  clearInput,
  onClickForExample,
  itemForExample,
  compact = false,
  id = 'search-input'
}) => (
  <div className={`search-input${compact ? ' search-input--compact' : ''}`}>
    <Picture
      pictureClassName='search-input__btn'
      icon={searchDGOutlined}
      height='24'
      width='24'
    />
    <input
      id={id}
      type='search'
      autoComplete='off'
      placeholder={compact ? 'Поиск в Деликатеске' : 'Поиск'}
      value={value}
      onChange={onChange}
      onFocus={onFocus}
      onBlur={onBlur}
      onKeyUp={onKeyUp}
    />
    <div className='search-input__wrapper'>
      {value !== '' ? (
        <Picture
          icon={closeDGOutlined.x2}
          iconHover={closeRedOutined.x2}
          height='18'
          width='18'
          onClick={clearInput}
        />
      ) : (
        <div onClick={onClickForExample} className='search-input__example'>
          Например,{' '}
          <label htmlFor='search-input'>
            {itemForExample || 'черная икра'}
          </label>
        </div>
      )}
    </div>
  </div>
);

export default observer(SearchInput);
